import {
  BLOCKING_CATEGORY_ALIASES,
  STAT_CATEGORY_TABS,
  STAT_SUB_CATEGORY_TABS,
} from './StatCategoryTabs.constants';

export const buildScoutTabs = (
  statCategories,
  allowedTabLabels,
  allowedChildren,
  condensed,
) =>
  statCategories
    .filter((tab) => !condensed || allowedTabLabels.includes(tab.name))
    .map((tab, index) => ({
      label: tab.name,
      value: index,
      subcategories: tab.subcategories,
      children: tab.subcategories
        .filter(
          (subTab) =>
            !condensed ||
            (allowedChildren[tab.name]
              ? allowedChildren[tab.name].includes(subTab.name)
              : true),
        )
        .map((subTab, subIndex) => ({
          label: subTab.name,
          name: subTab.name,
          value: subIndex,
          stats: subTab.stats,
        })),
    }));

// Utility to always put 'Bio' first and remove duplicates
export const getAllowedTabLabels = (positions) => {
  let labels = [];
  if (Array.isArray(positions)) {
    labels = positions.flatMap((pos) => STAT_CATEGORY_TABS[pos] || []);
  } else {
    labels = STAT_CATEGORY_TABS[positions] || [];
  }
  // Remove duplicates and ensure 'Bio' is first
  return ['Bio', ...[...new Set(labels)].filter((label) => label !== 'Bio')];
};

// Utility to merge allowed children for all positions
export const getAllowedChildren = (positions) => {
  if (Array.isArray(positions)) {
    return positions.reduce((acc, pos) => {
      const childrenForPos = STAT_SUB_CATEGORY_TABS[pos] || {};
      Object.entries(childrenForPos).forEach(([tabName, children]) => {
        acc[tabName] = acc[tabName]
          ? [...new Set([...acc[tabName], ...children])]
          : [...children];
      });
      return acc;
    }, {});
  }
  return STAT_SUB_CATEGORY_TABS[positions] || {};
};

// Maps a persisted category name onto the name the API currently returns, so a
// saved 'Offensive Line' selection survives the rename to 'Blocking' (and back)
export const resolveCategoryName = (categoryName, availableNames) => {
  if (
    availableNames.includes(categoryName) ||
    !BLOCKING_CATEGORY_ALIASES.includes(categoryName)
  ) {
    return categoryName;
  }
  return (
    BLOCKING_CATEGORY_ALIASES.find((alias) => availableNames.includes(alias)) ||
    categoryName
  );
};
